module.exports = __webpack_public_path__ + "assets/img/icon-success-bid.4a026391.png";